<template>
  <svg width="34px" height="29px" viewBox="0 0 34 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Group" fill="#ED1C23" fill-rule="nonzero">
        <path d="M0.899214998,25.7262455 C6.75499383,21.5927276 14.2612537,14.8074672 18.4345477,5.46373252 C21.0387417,-0.11224186 25.9005743,-0.296492243 28.5148266,0.680994902 C31.1309076,1.66259682 34.7601372,4.40532151 32.6401148,11.1348039 C30.5827285,17.6777499 24.036125,23.9802102 14.698334,26.959763 C6.03719458,29.7235187 1.59232561,27.1462993 0.836579013,26.7403084 C0.108721432,26.3548914 0.458934313,26.0458262 0.899214998,25.7262455" id="logoelement"></path>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'LogoElement'
  }
</script>

<style scoped>

</style>
